import { httpClient } from '../../../core/network';

export class StreamService {
  static fetchStreams(customerId: string) {
    const apiUrl = `/customers/${customerId}/streamlock`;
    return httpClient.get(apiUrl);
  }

  static deleteStream(customerId: string, streamId: string) {
    const apiUrl = `/customers/${customerId}/streamlock/${streamId}`;
    return httpClient.delete(apiUrl);
  }

  // static mockData =  [ {
  //   "userId": "12640685",
  //   "streamLockToken": "9937db23-8a5a-41b6-b6a6-ace37c3c8ebf",
  //   "playContentId": "ffef873a-e91e-45d8-9c98-e0ee6c26ff44",
  //   "ipAddress": "91.224.210.10",
  //   "platform": "Web",
  //   "platformClass": "chrome",
  //   "platformAppVersion": "2023.6.7070834",
  //   "platformAudience": "PLAY",
  //   "lastUpdatedAt": "2023-06-07T13:27:05.117178716Z",
  //   "expirationTime": 1686144515
  //   },
  //   {
  //   "userId": "12640685",
  //   "streamLockToken": "f5df74c6-619a-4b1d-81cb-1a514f05692f",
  //   "ipAddress": "91.224.210.10",
  //   "playContentId": "7eefdfdd-1002-427b-9281-e115e96f482d",
  //   "platform": "Web",
  //   "platformClass": "chrome",
  //   "platformAppVersion": "2023.6.7070834",
  //   "platformAudience": "PLAY",
  //   "lastUpdatedAt": "2023-06-07T13:27:14.995558880Z",
  //   "expirationTime": 1686144524
  //   }
  //  ];
}

export default StreamService;
